import styled, { css } from 'styled-components';
import Column from '~components/dumbs/Column';
import DefaultRow from '~components/dumbs/Row';
import ContractibleLogo from '~components/dumbs/ContractibleLogo';
import { ContainerProps } from './types';
import { BANNER_SPACE_PERCENTAGE, LEFT_SIDEBAR_WIDTH } from './constants';

export const LayoutWrapper = styled(DefaultRow)`
  display: flex;
  height: 100%;
`;

export const ContentContainer = styled(Column)<ContainerProps>`
  flex: 1;
  padding-top: ${({ theme }) => theme.spacing.km12};
  padding-right: ${({ $paddingRight, theme }) =>
    $paddingRight || theme.spacing.km12};
  padding-bottom: ${({ theme }) => theme.spacing.km6};
  padding-left: ${({ $paddingLeft, theme }) =>
    $paddingLeft || theme.spacing.km12};

  ${({ $disabledLayout }) =>
    $disabledLayout &&
    css`
      padding: ${({ theme }) => theme.spacing.km0};
    `}

  ${({ $hasBannerPadding }) =>
    $hasBannerPadding &&
    css`
      margin-right: ${BANNER_SPACE_PERCENTAGE};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km6};
    margin-right: ${({ theme }) => theme.spacing.km0};
    margin-left: ${({ theme }) => theme.spacing.km0};

    ${({ $disabledLayout }) =>
      $disabledLayout &&
      css`
        padding: ${({ theme }) => theme.spacing.km0};
      `}
  }
`;

export const LeftSidebar = styled.div`
  width: ${LEFT_SIDEBAR_WIDTH};
  flex: ${LEFT_SIDEBAR_WIDTH} 0 0;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.07);

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: none;
  }
`;

export const Logo = styled(ContractibleLogo)`
  margin-bottom: 76px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km10};
  }
`;
